export default __webpack_public_path__ + "static/media/you.da6217c8.svg";